export const blockIconsHomeLightGroupNew = (
	<span className='material-symbols-outlined'>light_group</span>
);
